import { render, staticRenderFns } from "./LgFormTextarea.vue?vue&type=template&id=1ca4c0e4&scoped=true"
import script from "./LgFormTextarea.vue?vue&type=script&lang=js"
export * from "./LgFormTextarea.vue?vue&type=script&lang=js"
import style0 from "./LgFormTextarea.vue?vue&type=style&index=0&id=1ca4c0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4c0e4",
  null
  
)

export default component.exports